import { Box, Text } from '@factorialco/deprecated-design-system'

import {
  EmployeePulseIcon,
  getEmployeeMoodToolTip,
} from 'modules/engagement/components/EmployeePulseIcon'

import './index.styles.css'
const MOOD_VALUES = [1, 2, 3, 4, 5] as const

interface Props {
  onChange: (mood: number) => void
  value?: number
  error?: string
}

export function MoodSelector({ onChange, value, error }: Props) {
  return (
    <Box>
      <Box flexDirection="row" gap="s8" alignItems="center">
        {MOOD_VALUES.map((mood) => {
          const isSelected = value === mood

          return (
            <label
              key={`pulse-value-${mood}`}
              aria-label={getEmployeeMoodToolTip(mood)}
              className={`${'MoodSelector_wrapper'} ${isSelected ? `MoodSelector_pulseColors_${mood}` : ''}`}
            >
              <input
                type="radio"
                onChange={(e) => onChange(Number(e.target.value))}
                checked={isSelected}
                value={mood}
                name="employee-pulse"
                className={'MoodSelector_input'}
              />
              <EmployeePulseIcon mood={mood} />
            </label>
          )
        })}
      </Box>

      {error && (
        <Text.Normal size="200" weight="medium" color="radicalRed1000">
          {error}
        </Text.Normal>
      )}
    </Box>
  )
}
